'use client';
import { MANIFEST_ILLUSTRATIONS } from '../manifest/illustrations.js';
import { getSameKeyValueMapForManifest, manifestResolve } from './manifest.utils.js';
import { SwanAssetFolders } from '../types/enums.js';

const SWAN_ILLUSTRATION_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_ILLUSTRATIONS);
function getSwanIllustrationUrl(o, e, n) {
    return manifestResolve(MANIFEST_ILLUSTRATIONS, o, SwanAssetFolders.ILLUSTRATIONS, e, n);
}

export { SWAN_ILLUSTRATION_KEY_MAP, getSwanIllustrationUrl };
